import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stepone',
  templateUrl: './stepone.component.html'
})
export class SteponeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
